"use strict";

(function () {
  'use strict';

  angular.module('lr.Settings').factory('EventSettingsFactory', EventSettingsFactory);
  EventSettingsFactory.$inject = ['User', '$lrNotifier', 'Utils', 'authEvents'];
  /* @ngInject */

  function EventSettingsFactory(User, $lrNotifier, Utils, authEvents) {
    var filterDataCache = [];
    var nameSpace;

    function activate() {
      var token = User.getToken();

      if (token) {
        nameSpace = 'lr_filterData' + token.ResUserID;
      } else {
        return;
      } //if no filter data populate storage


      if (!localStorage.getItem(nameSpace)) {
        populateStorage();
      }

      getFilters();
    }

    if (User.isAuthenticated()) {
      activate();
    } else {
      Utils.Publisher.subscribe(authEvents.success, function () {
        activate();
      });
    }

    var service = {
      saveFilters: saveFilters,
      getFilters: getFilters,
      filterOut: filterOut,
      eventFilters: filterDataCache,
      getLiveRezEventTypeIDs: getLiveRezEventTypeIDs
    };
    return service; ////////////////

    function getLiveRezEventTypeIDs() {
      var retArray = [];
      var list = null;

      if (filterDataCache !== null && filterDataCache.length) {
        list = filterDataCache;
      } else {
        list = getFilters();
      }

      for (var key in list) {
        if (list.hasOwnProperty(key)) {
          var data = list[key];
          retArray.push(data);
        }
      }

      return retArray;
    }
    /**
     *
     * @param value
     */


    function filterOut(value) {
      var index = filterDataCache.indexOf(value);

      if (index > -1) {
        filterDataCache.splice(index, 1);
      } else {
        filterDataCache.push(value);
      }
    }
    /**
     *
     * @returns {*}
     */


    function getFilters() {
      if (filterDataCache !== null && filterDataCache.length) {
        return filterDataCache;
      } else {
        return loadFilters();
      }
    }
    /**
     * populate storage
     */


    function populateStorage() {
      //todo: add default data to the storage
      var filters = [];
      localStorage.setItem(nameSpace, JSON.stringify(filters));
    }
    /**
     *
     */


    function loadFilters() {
      filterDataCache = JSON.parse(localStorage.getItem(nameSpace));
      return filterDataCache;
    }
    /**
     *
     */


    function saveFilters() {
      localStorage.setItem(nameSpace, JSON.stringify(filterDataCache));
      $lrNotifier.content('Settings Saved Successfully.').show();
    }
  }
})();